import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { SettingsService } from 'src/settings/settings.service';
import { ReferenceQuestion } from '../quiz/quiz.component';

@Injectable({
  providedIn: 'root'
})
export class QuizService {
  constructor(private http: HttpClient, private settingsService: SettingsService) {}

  get(url: string) {
    return this.http.get(url).pipe(map(res => res));
  }

  getAll() {
    return [
      { id: 'data/aspnet.json', name: 'Asp.Net' },
      { id: 'data/csharp.json', name: 'C Sharp' },
      { id: 'data/designPatterns.json', name: 'Design Patterns' }
    ];
  }

 determineInputType(q: ReferenceQuestion): 'dropdown' | 'radio' | 'rating' | 'textarea' {
  const count = q.answerChoiceList.length || 0;

  if (count === 0) return 'textarea';
  if (count === 5) return 'rating';
  if (count === 3) return 'radio';
  if (count === 4) return 'radio';
  return 'dropdown';
}


  GetProfile(Id: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': sessionStorage.getItem('token') || ''
    });

    return this.http
      .get(`${this.settingsService.settings.ProfilebaseUrl}/api/GetUserProfileInfo?profileId=${Id}`, { headers })
      .pipe(map(res => res));
  }
GetReferenceResults(Code: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': sessionStorage.getItem('token') || ''
    });

    return this.http
      .get(`${this.settingsService.settings.EmployerbaseUrl}/api/GetReferenceResponseRequestByCode?uniqueCode=${Code}`, { headers })
      .pipe(map(res => res));
  }
GetEmpResults(Code: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': sessionStorage.getItem('token') || ''
    });

    return this.http
      .get(`${this.settingsService.settings.EmployerbaseUrl}/api/GetEmploymentResponseRequestByCode?uniqueCode=${Code}`, { headers })
      .pipe(map(res => res));
  }
  GetReferenceQuestionsUpdated(Code: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': sessionStorage.getItem('token') || ''
    });

    return this.http
      .get(`${this.settingsService.settings.EmployerbaseUrl}/api/ReferenceQuestionsByCode?uniqueCode=${Code}`, { headers })
      .pipe(map(res => res));
  }

  GetCandidateExperiences(Pid: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': sessionStorage.getItem('token') || ''
    });

    return this.http
      .get(`${this.settingsService.settings.ProfilebaseUrl}/api/GetExperience?profileId=${Pid}&freeLance=0`, { headers })
      .pipe(map(res => res));
  }
   GetCompanies(prams: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': sessionStorage.getItem('token') || ''
    });

    return this.http
      .get(`${this.settingsService.settings.EmployerbaseUrl}/api/GetProfileJobTitles?ProfileId=${prams}`, { headers })
      .pipe(map(res => res));
  }
  GetService(prams: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': sessionStorage.getItem('token') || ''
    });

    return this.http
      .get(`${this.settingsService.settings.ProfilebaseUrl}/api/GetQuestionnaireQuestions?uniqueCode=${prams}`, { headers })
      .pipe(map(res => res));
  }

   GetEmpService(prams: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': sessionStorage.getItem('token') || ''
    });

    return this.http
      .get(`${this.settingsService.settings.EmployerbaseUrl}/api/GetEmploymentCheckquestions?Code=${prams}`, { headers })
      .pipe(map(res => res));
  }

   GetEmpDetailsService(prams: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': sessionStorage.getItem('token') || ''
    });

    return this.http
      .get(`${this.settingsService.settings.EmployerbaseUrl}/api/GetEmploymentCheckDetailsByCode?uniqueCode=${prams}`, { headers })
      .pipe(map(res => res));
  }

  PostService(body: any) {
    return this.http
      .post(`${this.settingsService.settings.ProfilebaseUrl}/api/SaveQuestionnaireResponses`, body)
      .pipe(map(res => res));
  }

    PostAdminEmailService(body: any) {
    return this.http
      .post(`${this.settingsService.settings.EmailbaseUrl}/api/SendAdminEmailEmpStatusFormUpdated`, body)
      .pipe(map(res => res));
  }

     PostCandidateEmailService(body: any) {
    return this.http
      .post(`${this.settingsService.settings.EmailbaseUrl}/api/SendCandidateEmailEmpStatusFormUpdated`, body)
      .pipe(map(res => res));
  }

    PostRefService(body: any) {
    return this.http
      .post(`${this.settingsService.settings.EmployerbaseUrl}/api/SaveReferenceResponseRequestByCode`, body)
      .pipe(map(res => res));
  }

   PostEmpService(body: any) {
    return this.http
      .post(`${this.settingsService.settings.EmployerbaseUrl}/api/SaveEmploymentResponseRequestByCode`, body)
      .pipe(map(res => res));
  }

  postRelation(data: any) {
    return this.http.post(`${this.settingsService.settings.adminbaseUrl}/api/QuestionnaireQuestion`, data);
  }
}